import React from "react";
import PropTypes from "prop-types";

const CardForUsers = ({
  statTitle,
  statData,
  messageTypes,
  statIconName,
  statIconColor,
  statIconStyle, // Added prop for icon style
  statTitleColor, // Added prop for title color
}) => {
  return (
    <div className="relative flex flex-col min-w-0 break-words bg-white rounded mb-6 xl:mb-0 shadow-lg">
      <div className="flex-auto p-4">
        <div className="flex flex-wrap">
          <div className="relative w-full pr-4 max-w-full flex-grow flex-1">
            {/* Applying dynamic color to statTitle */}
            <h5
              className={`text-gray-800 uppercase font-bold text-lg rmnmb-2 ${statTitleColor}`}
            >
              <span style={{ fontWeight: "bold" }}> {statTitle}</span>
            </h5>
            <span className="font-semibold text-xl text-gray-800">
              <span className="text-sm font-bold">{statData}</span>
            </span>
          </div>
        </div>
        <div className="text-sm text-gray-600 mt-2">
          {/* Flexbox layout for horizontal alignment */}
          {Object.entries(messageTypes).map(([key, value]) => (
            <div
              key={key}
              className="flex justify-between items-center mb-1"
              style={{ marginRight: "15px" }}
            >
              <span className="text-gray-500">{key}</span>
              <span className="font-bold text-gray-800">{value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

CardForUsers.propTypes = {
  statTitle: PropTypes.string.isRequired,
  statData: PropTypes.number.isRequired,
  messageTypes: PropTypes.object.isRequired,
  statIconName: PropTypes.string.isRequired,
  statIconColor: PropTypes.string.isRequired,
  statIconStyle: PropTypes.string, // Added prop type
  statTitleColor: PropTypes.string, // Added prop type
};

export default CardForUsers;
